import React from 'react';
import styles from './Modal.module.css';

/**
 * ModalFooter Component
 *
 * Footer section for Modal component
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Footer content (typically buttons)
 * @param {string} props.className - Additional CSS classes
 */
const ModalFooter = ({ children, className = '' }) => {
  const footerClasses = [styles.footer, className].filter(Boolean).join(' ');

  return <div className={footerClasses}>{children}</div>;
};

export default ModalFooter;
